/**
 * Supply Plan Free API — Feb 2026 mid-month.
 *
 * Public /supply-plans lead-magnet: one free supply plan per email.
 * The client trusts the server on cost protection (per-email + daily
 * ceiling). All three endpoints are anonymous / public.
 */
import { api } from "./api";

export async function requestSupplyPlan({ email, grade, prompt, consentMarketing }) {
  const { data } = await api.post("/supply-plan-free/request", {
    email,
    grade,
    prompt,
    consent_marketing: !!consentMarketing,
  });
  return data;
  // { status: "sent" | "already_claimed", token?, email, delivery_mode? }
}

export async function shareSupplyPlan({ token, colleagueEmail, note }) {
  const { data } = await api.post("/supply-plan-free/share", {
    token,
    colleague_email: colleagueEmail,
    note: note || null,
  });
  return data;
  // { status: "sent" | "already_shared", colleague_email, delivery_mode? }
}

export async function fetchSupplyPlan(token) {
  const { data } = await api.get(
    `/supply-plan-free/by-token/${encodeURIComponent(token)}`,
  );
  return data;
}

export function supplyPlanPdfUrl(token) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  return `${base}/api/supply-plan-free/by-token/${encodeURIComponent(token)}/pdf`;
}
